import { BaseModel } from "./base.model";
import { CustomerModel } from "./customer-model";

export class CasinoGameModel extends BaseModel {
  private customer;
  private config;
  private userSessionService;

  public window: any;

  // game properties
  public id: number;
  public game_name: string;

  // custom game properties
  public url: any;
  public is_demo:boolean;
  public instanceViewLocation: string;

  //device
  public isMobileApp:boolean;

  constructor(
    data,
    config,
    customer: CustomerModel,
    userSessionService,
    isMobileApp: boolean
  ){
    super();

    this.config = config;
    this.customer = customer;
    this.isMobileApp = isMobileApp;
    this.userSessionService = userSessionService;
    Object.assign(this, data);

    const extraLaunchDataForLD = ((data?.extra_launch_data) ? JSON.parse(data.extra_launch_data) : null);
    this.url = (extraLaunchDataForLD && 'lobby_launch' in extraLaunchDataForLD && extraLaunchDataForLD.lobby_launch === 'LIVEDEALER') ? this.generateBrowseWindowUrlForLiveDealer(data) : this.generateBrowseWindowUrl();

    this.setIdentifier(this.id);
    this.setLabel(this.game_name);
    this.setInstanceCategoryType('casino-game');
  }

  public generateBrowseWindowUrl() {
    let url = '';
    //        let appUrl = this.config.getConfig().WEBSERVICES_URL;
    let appUrl = this.config.getEnv().webservices_url;

    let params = new URLSearchParams();
    if (this.customer) {
      this.is_demo = false;
      params.set('noredirect','true');
      params.set('customer_id', this.customer.customerId.toString());
      if(this.isMobileApp) {
        params.set('session_token', this.userSessionService.sessionToken);
      }
    } else {
      this.is_demo = true;
      params.set('customer_id', '');
      params.set('session_token', '');
    }
    const skipActiveBonusCheck = localStorage.getItem('skipActiveBonusCheck');
    if (skipActiveBonusCheck) {
      params.set('skip_active_bonus_check', 'true');
      localStorage.removeItem('skipActiveBonusCheck');
    }

    params.set('game_launcher_id', this.id.toString());
    params.set('gameName', this.game_name);
    let clientApp = this.config.getClientApp();
    params.set('clientapp', clientApp);

    url = `${appUrl}/games/launch-casino?${params.toString()}`;
    return url;
  }

  public generateBrowseWindowUrlForLiveDealer(data) {
    let url = '';
    let appUrl = this.config.getEnv().webservices_url;

    let params = new URLSearchParams();
    if (this.customer) {
      this.is_demo = false;
      params.set('noredirect','1');
      params.set('customer_id', this.customer.customerId.toString());
      if(this.isMobileApp) {
        params.set('session_token', this.userSessionService.sessionToken);
      }
    } else {
      this.is_demo = true;
      params.set('customer_id', '');
      params.set('session_token', '');
    }
    const skipActiveBonusCheck = localStorage.getItem('skipActiveBonusCheck');
    if (skipActiveBonusCheck) {
      params.set('skip_active_bonus_check', 'true');
      localStorage.removeItem('skipActiveBonusCheck');
    }
    params.set('game_launcher_id', this.id.toString());
    params.set('gameName', this.game_name);
    params.set('vendor', data.vendor_ident);
   
    const extraLaunchData = JSON.parse(data.extra_launch_data);
    if(extraLaunchData?.lobby_category)params.set('category', extraLaunchData?.lobby_category);
    let clientApp = this.config.getClientApp();
    params.set('clientapp', clientApp);

    url = `${appUrl}/games/launch-lobby?${params.toString()}`;
    return url;
  }
}
